import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const name = "inbox";
const purchaseCredits = "PurchaseCredits";
const initialState = createInitialState();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers: {
    setTotalMessages: (state, action) => {
      state.totalMessages = action.payload;
    },
    incrementPage: (state) => {
      state.currentPage += 1;
    },
  },
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const inboxActions = { ...slice.actions, ...extraActions };
export const inboxReducer = slice.reducer;

function createInitialState() {
  return {
    inboxMessagesList: [],
    PublicInboxMessageSubjectList: [],
    publicInboxMessageHistoryList: [],
    LoadPublicMyContactsDisplayList: [],
    CreditStatusResponse: [],
    MultiUpdateCODMessageResponse: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalMessages: 0,
  };
}

function createReducers() {
  return {};
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/Inbox`;
  const purchasecreditbaseurl = `${process.env.REACT_APP_API_URL}/PublicUser/PurchaseCredits`;
  const commonBaseUrl = `${process.env.REACT_APP_API_URL}/Common`;

  return {
    LoadInboxMessages: LoadInboxMessages(),
    LoadPublicInboxMessageSubject: LoadPublicInboxMessageSubject(),
    LoadPublicInboxMessageHistory: LoadPublicInboxMessageHistory(),
    LoadPublicMyContactsDisplay: LoadPublicMyContactsDisplay(),
    MessagePhotoCODClear: MessagePhotoCODClear(),
    LockdownPODRestriction: LockdownPODRestriction(),
    InsertUpdatePublicInboxMessageDelete: InsertUpdatePublicInboxMessageDelete(),
    PublicInboxMessageSubjectPurchaseDisabled: PublicInboxMessageSubjectPurchaseDisabled(),
    MultiUpdateCODMessage: MultiUpdateCODMessage(),

    InsertUpdatePublicInboxMessageDelete:
      InsertUpdatePublicInboxMessageDelete(),
    PublicInboxMessageSubjectPurchaseDisabled:
      PublicInboxMessageSubjectPurchaseDisabled(),
    MultiDeleteMessage: MultiDeleteMessage(),
    //LoadUpdatePUInboxReadStatus: UpdatePUInboxReadStatus()
  };

  // function UpdatePUInboxReadStatus() {
  //   return createAsyncThunk(
  //     `${name}/UpdatePUInboxReadStatus`,
  //     async ({ messageID }) =>
  //       await fetchWrapper.post(`${baseUrl}/UpdatePUInboxReadStatus?messageID=${messageID}`)
  //   );
  // }

  function LoadInboxMessages() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageWeb`,
      async (data, { rejectWithValue }) => {
        const response = await fetchWrapper.post(
          `${baseUrl}/PublicInboxMessageWeb`,
          data
        );
        return response;
      }
    );
  }

  // function LoadPublicInboxMessageSubject() {
  //   return createAsyncThunk(
  //     `${name}/PublicInboxMessageSubject`,
  //     async ({ MessageID, PublicUserID }, { rejectWithValue }) => {
  //       const response = await fetchWrapper.post(
  //         `${baseUrl}/PublicInboxMessageSubject?messageId=${MessageID}&userId=${PublicUserID}`
  //       );
  //       return response;
  //     }
  //   );
  // }

    function LoadPublicInboxMessageSubject() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageSubject`,
      async ({ MessageID, PublicUserID }) => {

        // Determine final IDs with fallback
        const Message = MessageID;
        const PUserId = PublicUserID;

        // Stop API call if any value is missing
        if (!Message || !PUserId) {
          return;
        }

        // API call
        const url =  `${baseUrl}/PublicInboxMessageSubject?messageId=${Message}&userId=${PUserId}`

        return await fetchWrapper.post(url);
      }
    );
  }

  function LoadPublicInboxMessageHistory() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageHistory`,
      async (
        { MessageID, isHoldCOD, pageNo, rowCountPerPage },
        { rejectWithValue }
      ) => {
        const response = await fetchWrapper.post(
          `${baseUrl}/PublicInboxMessageHistory?messageId=${MessageID}&isHoldCOD=${isHoldCOD}&pageNo=${pageNo}&rowCountPerPage=${rowCountPerPage}`
        );
        return response;
      }
    );
  }

  function LoadPublicMyContactsDisplay() {
    return createAsyncThunk(
      `${name}/LoadPublicMyContactsDisplay`,
      async (
        { userId, inmatesId, activeStatus, inmateLoadPurpose, sortField },
        { rejectWithValue }
      ) => {
        const response = await fetchWrapper.post(
          `${commonBaseUrl}/LoadPublicMyContactsDisplay?userId=${userId}&inmatesId=${inmatesId}&activeStatus=${activeStatus}&inmateLoadPurpose=${inmateLoadPurpose}&sortField=${sortField}`
        );
        return response;
      }
    );
  }

  // Function for - MessagePhotoCODClear
  function MessagePhotoCODClear() {
    return createAsyncThunk(
      `${name}/MessagePhotoCODClear`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/MessagePhotoCODClear`, addFormData)
    );
  }

  function LockdownPODRestriction() {
    return createAsyncThunk(
      `${purchaseCredits}/LockdownPODRestriction`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${purchasecreditbaseurl}/LockdownPODRestriction?inmateId=${addFormData.inmateId}&messageId=${addFormData.messageId}`
        )
    );
  }

  function InsertUpdatePublicInboxMessageDelete() {
    return createAsyncThunk(
      `${name}/InsertUpdatePublicInboxMessageDelete`,
      async (addFormData) =>
        await fetchWrapper.get(
          `${baseUrl}/InsertUpdatePublicInboxMessageDelete?userId=${addFormData.userId}&messageId=${addFormData.messageId}&facilityID=${addFormData.facilityID}`
        )
    );
  }
  function PublicInboxMessageSubjectPurchaseDisabled() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageSubjectPurchaseDisabled`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicInboxMessageSubjectPurchaseDisabled?userId=${addFormData.userId}&messageId=${addFormData.messageId}&inmateId=${addFormData.inmateId}`
        )
    );
  }
  function MultiUpdateCODMessage() {
    return createAsyncThunk(
      `${name}/MultiUpdateCODMessage`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/MultiUpdateCODMessage`, addFormData
        )
    );
  }
  function PublicInboxMessageSubjectPurchaseDisabled() {
    return createAsyncThunk(
      `${name}/PublicInboxMessageSubjectPurchaseDisabled`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicInboxMessageSubjectPurchaseDisabled?userId=${addFormData.userId}&messageId=${addFormData.messageId}&inmateId=${addFormData.inmateId}`
        )
    );
  }

  // API used for Multi Delete Message
  function MultiDeleteMessage() {
    return createAsyncThunk(
      `${name}/MultiDeleteMessage`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/MultiDeleteMessage`, addFormData)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(inboxActions.LoadInboxMessages.pending, (state) => {
      state.loading = true;
    })
    .addCase(inboxActions.LoadInboxMessages.fulfilled, (state, action) => {
      state.inboxMessagesList = action.payload || [];
      state.loading = false;
    })
    .addCase(inboxActions.LoadInboxMessages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(inboxActions.LoadPublicInboxMessageSubject.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      inboxActions.LoadPublicInboxMessageSubject.fulfilled,
      (state, action) => {
        state.PublicInboxMessageSubjectList = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      inboxActions.LoadPublicInboxMessageSubject.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    )
    .addCase(inboxActions.LoadPublicInboxMessageHistory.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      inboxActions.LoadPublicInboxMessageHistory.fulfilled,
      (state, action) => {
        state.publicInboxMessageHistoryList = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      inboxActions.LoadPublicInboxMessageHistory.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    )
    .addCase(inboxActions.LoadPublicMyContactsDisplay.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      inboxActions.LoadPublicMyContactsDisplay.fulfilled,
      (state, action) => {
        state.LoadPublicMyContactsDisplayList = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      inboxActions.LoadPublicMyContactsDisplay.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    )

    // MessagePhotoCODClear - Check Response
    .addCase(inboxActions.MessagePhotoCODClear.pending, (state) => {
      state.loading = true;
    })
    .addCase(inboxActions.MessagePhotoCODClear.fulfilled, (state, action) => {
      // state.LoadPublicMyContactsDisplayList = action.payload;
      // state.loading = false;
    })
    .addCase(inboxActions.MessagePhotoCODClear.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // MessagePhotoCODClear - Check Response
    .addCase(inboxActions.LockdownPODRestriction.pending, (state) => {
      state.loading = true;
    })
    .addCase(inboxActions.LockdownPODRestriction.fulfilled, (state, action) => {
      // state.LoadPublicMyContactsDisplayList = action.payload;
      // state.loading = false;
    })
    .addCase(inboxActions.LockdownPODRestriction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // Message Conversation - Delete
    .addCase(
      inboxActions.InsertUpdatePublicInboxMessageDelete.pending,
      (state) => {
        state.loading = true;
      }
    )
    .addCase(
      inboxActions.InsertUpdatePublicInboxMessageDelete.fulfilled,
      (state, action) => {
        // state.LoadPublicMyContactsDisplayList = action.payload;
        // state.loading = false;
      }
    )
    .addCase(
      inboxActions.InsertUpdatePublicInboxMessageDelete.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    )

    .addCase(

      inboxActions.PublicInboxMessageSubjectPurchaseDisabled.pending,
      (state) => {
        state.loading = true;
      }
    )
    .addCase(
      inboxActions.PublicInboxMessageSubjectPurchaseDisabled.fulfilled,
      (state, action) => {
        state.CreditStatusResponse = action.payload || [];
        state.loading = false;
      }
    )
    .addCase(
      inboxActions.PublicInboxMessageSubjectPurchaseDisabled.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    )
    // MultiUpdateCODMessage - Check Response
    .addCase(inboxActions.MultiUpdateCODMessage.pending,
      (state) => {
        state.loading = true;
      }
    )
    .addCase(
      inboxActions.MultiUpdateCODMessage.fulfilled,
      (state, action) => {
        // state.LoadPublicMyContactsDisplayList = action.payload;
        // state.loading = false;
        state.MultiUpdateCODMessageResponse = action.payload || [];
      }
    )
    .addCase(
      inboxActions.MultiUpdateCODMessage.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    )

    // MultiDelete Option Reducer 

    .addCase(
      inboxActions.MultiDeleteMessage.pending,
      (state) => {
        state.loading = true;
      }
    )
    .addCase(
      inboxActions.MultiDeleteMessage.fulfilled,
      (state, action) => {
        // state.CreditStatusResponse = action.payload || [];
        // state.loading = false;
      }
    )
    .addCase(
      inboxActions.MultiDeleteMessage.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }
    );



}
